import { useEffect, useState } from "@wordpress/element";
import { useSelector, useDispatch } from "react-redux";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {
	selectProductCollections,
	getProductCollections,
} from "store/vino/productCollectionsSlice";
import { getProductsByCollection, getProducts } from "store/vino/productsSlice";

const CollectionList = () => {
	const [collectionIds, setCollectionIds] = useState([]);
	const dispatch = useDispatch();
	const collections = useSelector(selectProductCollections);

	useEffect(() => {
		dispatch(getProductCollections());
	}, [dispatch]);

	const handleChange = (checked, id) => {
		let ids = [...collectionIds];
		if (checked) {
			ids.push(id);
		} else {
			ids = ids.filter((item) => item !== id);
		}
		setCollectionIds(ids);
		if (ids.length > 0) {
			dispatch(getProductsByCollection(ids));
		} else {
			dispatch(getProducts());
		}
	};

	return (
		<div className="flex flex-col">
			<FormGroup>
				{collections.map((collection) => (
					<CollectionListItem
						key={collection.id}
						onChange={handleChange}
						collection={collection}
					/>
				))}
			</FormGroup>
		</div>
	);
};

export default CollectionList;

const CollectionListItem = ({ collection, onChange }) => {
	const [isSelected, setSelected] = useState(false);
	const handleChange = (event) => {
		const { checked } = event.target;
		setSelected(checked);
		onChange(checked, collection.id);
	};

	return (
		<div className="flex form-check py-3">
			<FormControlLabel
				control={<Checkbox checked={isSelected} onChange={handleChange} />}
				label={collection.name}
			/>
		</div>
	);
};
